import { useEffect, useRef } from 'react';
import customSolutionsIcon from './AssetsForPage/custom-solutions.svg';
import StrategicConsulting from './AssetsForPage/strategic-consulting.svg';
import Support from './AssetsForPage/Support.svg';
import launchpackage from './AssetsForPage/launch-package.svg';
import feature from './AssetsForPage/included-feature.svg';
import './App.css';

function AnimatedWaveBackground() {
  const canvasRef = useRef(null);

  useEffect(() => {
    const canvas = canvasRef.current;
    const context = canvas.getContext('2d');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    let animationFrame;
    let width = 0;
    let height = 0;
    let startTime = performance.now();

    const resize = () => {
      const pixelRatio = Math.min(window.devicePixelRatio || 1, 2);
      width = canvas.clientWidth;
      height = canvas.clientHeight;
      canvas.width = Math.round(width * pixelRatio);
      canvas.height = Math.round(height * pixelRatio);
      context.setTransform(pixelRatio, 0, 0, pixelRatio, 0, 0);
    };

    const drawWave = (time, settings) => {
      const {
        baseY,
        amplitude,
        frequency,
        phase,
        rows,
        spacing,
        opacity,
        speed,
      } = settings;

      for (let row = -rows; row <= rows; row += 1) {
        const rowDistance = Math.abs(row) / rows;
        const rowAlpha = (1 - rowDistance * 0.72) * opacity;

        for (let x = -spacing; x <= width + spacing; x += spacing) {
          const progress = x / Math.max(width, 1);
          const drift = reducedMotion.matches ? 0 : time * speed;
          const primaryCurve = Math.sin(progress * frequency + phase + drift);
          const detailCurve = Math.sin(progress * frequency * 0.48 - phase + drift * 0.6);
          const perspective = 0.55 + progress * 0.75;
          const y =
            height * baseY +
            primaryCurve * height * amplitude +
            detailCurve * height * amplitude * 0.24 +
            row * 4.2 * perspective;
          const centerFade = Math.sin(Math.PI * Math.max(0, Math.min(1, progress)));
          const alpha = Math.max(0, rowAlpha * (0.28 + centerFade * 0.72));
          const radius = 0.65 + perspective * 0.55;

          context.beginPath();
          context.fillStyle = `rgba(55, 91, 255, ${alpha})`;
          context.arc(x, y, radius, 0, Math.PI * 2);
          context.fill();
        }
      }
    };

    const drawLights = (time) => {
      const lights = [
        [0.17, 0.13, 2.4, 0.3],
        [0.79, 0.19, 2, 1.8],
        [0.31, 0.71, 2.8, 3.2],
        [0.84, 0.78, 3.4, 4.4],
        [0.52, 0.9, 2.2, 5.1],
      ];

      lights.forEach(([x, y, radius, phase]) => {
        const movement = reducedMotion.matches ? 0 : Math.sin(time * 0.18 + phase);
        const lightX = x * width + movement * 8;
        const lightY = y * height + movement * 5;
        const glow = context.createRadialGradient(
          lightX,
          lightY,
          0,
          lightX,
          lightY,
          radius * 5
        );
        glow.addColorStop(0, 'rgba(150, 158, 255, 0.85)');
        glow.addColorStop(0.2, 'rgba(87, 101, 255, 0.55)');
        glow.addColorStop(1, 'rgba(32, 58, 210, 0)');
        context.fillStyle = glow;
        context.fillRect(
          lightX - radius * 5,
          lightY - radius * 5,
          radius * 10,
          radius * 10
        );
      });
    };

    const render = (timestamp) => {
      const time = (timestamp - startTime) / 1000;
      const background = context.createLinearGradient(0, 0, width, height);
      background.addColorStop(0, '#020711');
      background.addColorStop(0.48, '#030916');
      background.addColorStop(1, '#01040c');
      context.fillStyle = background;
      context.fillRect(0, 0, width, height);

      drawWave(time, {
        baseY: 0.33,
        amplitude: 0.095,
        frequency: 6.2,
        phase: 0.4,
        rows: 16,
        spacing: 14,
        opacity: 0.62,
        speed: 0.09,
      });
      drawWave(time, {
        baseY: 0.57,
        amplitude: 0.075,
        frequency: 7.4,
        phase: 2.2,
        rows: 11,
        spacing: 17,
        opacity: 0.32,
        speed: -0.065,
      });
      drawWave(time, {
        baseY: 0.78,
        amplitude: 0.055,
        frequency: 5.5,
        phase: 4.1,
        rows: 7,
        spacing: 20,
        opacity: 0.2,
        speed: 0.045,
      });
      drawLights(time);

      if (!reducedMotion.matches) {
        animationFrame = requestAnimationFrame(render);
      }
    };

    const handleMotionPreference = () => {
      cancelAnimationFrame(animationFrame);
      startTime = performance.now();
      render(startTime);
    };

    resize();
    render(startTime);
    window.addEventListener('resize', resize);
    reducedMotion.addEventListener('change', handleMotionPreference);

    return () => {
      cancelAnimationFrame(animationFrame);
      window.removeEventListener('resize', resize);
      reducedMotion.removeEventListener('change', handleMotionPreference);
    };
  }, []);

  return (
    <canvas
      ref={canvasRef}
      className="wave-background"
      aria-hidden="true"
    />
  );
}

function App() {
  return (
    <div className="back-ground">
      <AnimatedWaveBackground />
      <Widget_largest/>
      <Widget_Packages/>
      <ContactSection/>
    </div>

  );
}


export default App;





// The start of the first third widgets of the screen

function Widget_largest(){
    return(  <div className="widget">
              <h1 className="My_name"  >
                Malcolm Andrew Lott
              </h1>
          <h2 className="Software_consulting">
            Software Consulting
          </h2>

          <h3 className="Line"></h3>
          <h4 className="Line2"></h4>
          <h4 className="Where-your-software-needs-are-met">
            Where your software needs are met.
          </h4>
          <p className="Description1">
            Reliable software solutions.Strategic guidance.

            <br></br>


            Built to solve real problems and drive real results.
          </p>
          <div className="feature-list">
            <div className="feature-item">
              <img
                className="feature-icon"
                src={customSolutionsIcon}
                alt=""
              />
              <h5 className="feature-heading">Custom solutions</h5>
              <p className="feature-description">Built for your business</p>
            </div>

            <div className="feature-item">
              <img
                className="feature-icon"
                src={StrategicConsulting}
                alt=""
              />
              <h5 className="feature-heading">Strategic Consulting</h5>
              <p className="feature-description">Guidance that scales</p>
            </div>

            <div className="feature-item">
              <img
                className="feature-icon"
                src={Support}
                alt=""
              />
              <h5 className="feature-heading">Ongoing Support</h5>
              <p className="feature-description">We're with you</p>
            </div>
          </div>
        </div>


    );
}

function Widget_Packages(){
  return(
      <div className="package_widget">

         <h1 className="Our-Packages">
           Our Packages
         </h1>

        <h2 className="Choose-the-right-solution-for-your-business">Choose the right solution for your business
        </h2>

       <div className="launch_package">
         <h1 className="launch_title">
           Launch Package
           <img

               className="launch_icon"

               src={launchpackage}

               alt="launch-package"

           />
         </h1>
         <h2  className="One_time">
           One-Time package
         </h2>

         <h3 className="phrase1">
           Perfect for business that need a
         </h3>
         <h4 className="phrase2">
           professional online presence fast.
         </h4>

         <ul className={"List-for-features"}>
           <li class={"feature1"}>
             <img className="included-features-icon"
                  src={feature}
                  alt=""
             />

             <span className="bullet1phrase"> Custom Webpage (up to 5 pages)
             </span>
           </li>

           <li className= "feature2">

             <img className="included-features-icon2"
                  src={feature}
                  alt=""/>
                <span className="bullet2phrase">
                  Mobile Responsive Design
                </span>


           </li>

           <li className="feature3">
             <img className="included-features-icon3"
                  src={feature}
                  alt=""

             />
          <span className="bullet3phrase">
            Contact form & basic integrations
          </span>

           </li>
         <li className="feature4">
           <img className="included-features-icon4"
                src={feature}
                alt=""

           />
           <span className="bullet4phrase">
             Domain Hosting
           </span>

         </li>

           <li className="feature5">
             <img className="included-features-icon5"
                  src={feature}
                  alt=""

             />
            <span className="bullet5phrase">
              1 round of revisions
            </span>
           </li>


           <span className="price">
             $295
           </span>

           <button className="buy1phrase">
             Buy Now
           </button>

         </ul>


         <h5 className="line_for_packages"></h5>


















       </div>
        <div className="launch_package2">
          <h1 className="launch_title">
            Growth Package
            <img className="launch_icon" src={launchpackage} alt="package 2" />
          </h1>

          <h2 className="One_time">Monthly Engagement</h2>
          <h3 className="phrase1">For businesses ready to grow  </h3>
          <h4 className="phrase2"> and imporve continously.  </h4>

          <ul className="List-for-features">
            <li className="feature1">
              <img className="included-features-icon" src={feature} alt="" />
              <span className="bullet1phrase">Everything in Launch Pacakge</span>
            </li>
            <li className="feature2">
              <img className="included-features-icon2" src={feature} alt="" />
              <span className="bullet2phrase">Ongoing updates & improvements</span>
            </li>
            <li className="feature3">
              <img className="included-features-icon3" src={feature} alt="" />
              <span className="bullet3phrase">Content updates (text/images)</span>
            </li>
            <li className="feature4">
              <img className="included-features-icon4" src={feature} alt="" />
              <span className="bullet4phrase">Package 2 feature four</span>
            </li>
            <li className="feature5">
              <img className="included-features-icon5" src={feature} alt="" />
              <span className="bullet5phrase">Feature enhancements & priority support</span>
            </li>

            <span className="price">$495</span>
            <button className="buy1phrase">Buy Now</button>
          </ul>

          <h5 className="line_for_packages"></h5>
        </div>

        <div className="launch_package3">
          <h1 className="launch_title">
            Consulting Package
            <img className="launch_icon" src={launchpackage} alt="package 3" />
          </h1>

          <h2 className="One_time">Strategic Engagements</h2>
          <h3 className="phrase1">Need expert guideance? Let's </h3>
          <h4 className="phrase2">solve your toughest challenges</h4>

          <ul className="List-for-features">
            <li className="feature1">
              <img className="included-features-icon" src={feature} alt="" />
              <span className="bullet1phrase">Strategy & technology consulting</span>
            </li>
            <li className="feature2">
              <img className="included-features-icon2" src={feature} alt="" />
              <span className="bullet2phrase">Process & workflow optimization</span>
            </li>
            <li className="feature3">
              <img className="included-features-icon3" src={feature} alt="" />
              <span className="bullet3phrase">Process & workflow optimization</span>
            </li>
            <li className="feature4">
              <img className="included-features-icon4" src={feature} alt="" />
              <span className="bullet4phrase">System architecture guidance</span>
            </li>
            <li className="feature5">
              <img className="included-features-icon5" src={feature} alt="" />
              <span className="bullet5phrase">vender & tool recommendations & On-demand advisory </span>
            </li>

            <span className="price">$150/hr</span>
            <button className="buy1phrase">Buy Now</button>
          </ul>

          <h5 className="line_for_packages"></h5>
        </div>


      </div>


  );
}

function ContactIcon({ type }) {
  const paths = {
    email: <><rect x="3" y="5" width="18" height="14" rx="2"/><path d="m4 7 8 6 8-6"/></>,
    phone: <path d="M7.2 3.8 10 7.1 8.1 9.4a15.3 15.3 0 0 0 6.5 6.5l2.3-1.9 3.3 2.8c.5.4.6 1.1.3 1.7-.7 1.3-2.1 2.2-3.6 2.2C9.4 20.7 3.3 14.6 3.3 7.1c0-1.5.9-2.9 2.2-3.6.6-.3 1.3-.2 1.7.3Z"/>,
    location: <><path d="M20 10c0 5-8 11-8 11S4 15 4 10a8 8 0 1 1 16 0Z"/><circle cx="12" cy="10" r="2.5"/></>,
    calendar: <><rect x="3" y="5" width="18" height="16" rx="2"/><path d="M8 3v4M16 3v4M3 10h18"/><path d="m14.5 14.5-3 3-1.5-1.5"/></>,
  };

  return (
    <span className={`contact-icon contact-icon-${type}`} aria-hidden="true">
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
        {paths[type]}
      </svg>
    </span>
  );
}

function ContactSection() {
  return (
    <section className="contact-section" aria-labelledby="contact-title">
      <div className="contact-heading">
        <p className="contact-eyebrow">Contact</p>
        <h2 id="contact-title">Let&apos;s Build Something Great Together</h2>
        <span className="contact-accent" aria-hidden="true"></span>
        <p className="contact-intro">
          Have a question or ready to start your project? Reach out<br className="contact-intro-break" />
          and let&apos;s discuss how we can help your business succeed.
        </p>
      </div>

      <div className="contact-content">
        <address className="contact-details">
          <div className="contact-row">
            <ContactIcon type="email" />
            <div>
              <p className="contact-label">Email</p>
              <a href="mailto:malcolmlott553@gmail.com">malcolmlott553@gmail.com</a>
            </div>
          </div>

          <div className="contact-row">
            <ContactIcon type="phone" />
            <div>
              <p className="contact-label">Phone</p>
              <a href="tel:+17038510198">(571) 746-1631</a>
            </div>
          </div>

          <div className="contact-row">
            <ContactIcon type="location" />
            <div>
              <p className="contact-label">Location</p>
              <p className="contact-value">Ashburn, VA 20147<br />Serving clients nationwide</p>
            </div>
          </div>
        </address>

        <span className="contact-divider" aria-hidden="true"></span>

        <div className="schedule-card">
          <ContactIcon type="calendar" />
          <div className="schedule-copy">
            <h3>Schedule a Call</h3>
            <p>Book a free 15-minute consultation<br />to discuss your needs.</p>
          </div>
          <button className="schedule-button" type="button">
            Schedule Now <span aria-hidden="true">→</span>
          </button>
        </div>
      </div>

      <p className="contact-copyright">
        © 2026 Malcolm Andrew Lott Software Consulting. All rights reserved.
      </p>
    </section>
  );
}
